import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 10000;
`;

export const ModalContent = styled.div`
  background: #000000;
  border-radius: 16px;
  border: 1px solid rgba(73, 251, 176, 0.3);
  backdrop-filter: blur(10px);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(73, 251, 176, 0.1);
  position: relative;
`;

export const ModalHeader = styled.div`
  position: relative;
  padding: 30px 30px 20px;
  text-align: center;
  border-bottom: 1px solid rgba(73, 251, 176, 0.2);
  background: transparent;
`;

export const ModalBody = styled.div`
  padding: 30px;
  overflow-y: auto;
  max-height: calc(90vh - 200px);
  scroll-behavior: smooth;
  
  /* Scroll gamificado */
  &::-webkit-scrollbar {
    width: 14px;
  }
  
  &::-webkit-scrollbar-track {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%);
    border-radius: 12px;
    border: 1px solid rgba(73, 251, 176, 0.3);
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #49fbb0 0%, #36d399 30%, #2dd4aa 70%, #1ce488 100%);
    border-radius: 12px;
    border: 2px solid rgba(0, 0, 0, 0.4);
    box-shadow: 
      0 0 10px rgba(73, 251, 176, 0.6),
      inset 0 1px 0 rgba(255, 255, 255, 0.2),
      inset 0 -1px 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
  }
  
  &::-webkit-scrollbar-thumb::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
    border-radius: 12px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #5afcc0 0%, #46e3a9 30%, #3de4ba 70%, #2ce598 100%);
    box-shadow: 
      0 0 20px rgba(73, 251, 176, 0.8),
      inset 0 1px 0 rgba(255, 255, 255, 0.3),
      inset 0 -1px 0 rgba(0, 0, 0, 0.3);
    transform: scale(1.02);
  }
  
  &::-webkit-scrollbar-thumb:hover::before {
    opacity: 1;
  }
  
  &::-webkit-scrollbar-thumb:active {
    background: linear-gradient(180deg, #36d399 0%, #2dd4aa 30%, #1ce488 70%, #0fb876 100%);
    transform: scale(0.98);
  }
  
  &::-webkit-scrollbar-corner {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%);
  }
  
  /* Para Firefox */
  scrollbar-width: thin;
  scrollbar-color: #49fbb0 rgba(0, 0, 0, 0.3);
  
  @media (max-width: 600px) {
    padding: 20px;
    
    &::-webkit-scrollbar {
      width: 10px;
    }
    
    &::-webkit-scrollbar-track {
      border-radius: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
    }
  }
`;

export const TimelineContainer = styled.div`
  margin: 0;
  padding: 20px 30px;
  background: rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid rgba(73, 251, 176, 0.2);
`;

export const TimelineTitle = styled.h3`
  color: #49fbb0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
`;

export const TimelineSteps = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  padding: 0 20px;
  min-height: 60px;
  
  &::before {
    content: '';
    position: absolute;
    top: 20px; /* Centro do círculo (40px altura / 2) */
    left: 40px;
    right: 40px;
    height: 2px;
    background: linear-gradient(90deg, #49fbb0 0%, rgba(73, 251, 176, 0.3) 100%);
    z-index: 1;
  }
  
  @media (max-width: 600px) {
    padding: 0 17px;
    min-height: 50px;
    
    &::before {
      top: 17.5px; /* Centro do círculo (35px altura / 2) */
      left: 34.5px;
      right: 34.5px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0 15px;
    
    &::before {
      top: 15px; /* Centro do círculo (30px altura / 2) */
      left: 30px;
      right: 30px;
    }
  }
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  z-index: 2;
`;

export const TimelineStep = styled.div<{ active?: boolean; completed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  background: ${props => props.completed ? '#49fbb0' : props.active ? '#2d7a5f' : '#15151a'};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  justify-content: center;
  border: 2px solid ${props => props.completed ? '#49fbb0' : props.active ? '#49fbb0' : '#49fbb0'};
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  &:hover {
    transform: scale(1.1);
  }
  
  @media (max-width: 600px) {
    width: 35px;
    height: 35px;
  }
  
  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
  }
`;

export const StepNumber = styled.span<{ completed?: boolean; active?: boolean }>`
  color: ${props => props.completed ? '#0d4f3c' : props.active ? '#49fbb0' : '#49fbb0'};
  font-weight: bold;
  font-size: 1rem;
  
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const StepLabel = styled.span<{ active?: boolean; completed?: boolean }>`
  color: ${props => props.completed ? '#49fbb0' : props.active ? '#49fbb0' : 'rgba(255, 255, 255, 0.7)'};
  font-size: 0.7rem;
  margin-top: 6px;
  text-align: center;
  font-weight: 500;
  
  @media (max-width: 600px) {
    font-size: 0.65rem;
    margin-top: 4px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.6rem;
    margin-top: 3px;
  }
`;

export const StepDescription = styled.div<{ active?: boolean; completed?: boolean }>`
  color: ${props => props.completed ? '#49fbb0' : props.active ? '#49fbb0' : 'rgba(255, 255, 255, 0.6)'};
  font-size: 0.65rem;
  text-align: center;
  margin-top: 3px;
  max-width: 60px;
  
  @media (max-width: 600px) {
    font-size: 0.6rem;
    max-width: 50px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.55rem;
    max-width: 45px;
  }
`;

// Estilos RPG para o card premium
export const PremiumCardContainer = styled.div`
  animation: slideInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  
  &:nth-child(1) {
    animation-delay: 0.1s;
  }
  
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  @keyframes slideInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Background RPG animado */
  &::before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    background: linear-gradient(45deg, 
      #49fbb0, #36d399, #2dd4aa, #1ce488, #0fb876,
      #49fbb0, #36d399, #2dd4aa, #1ce488, #0fb876
    );
    background-size: 300% 300%;
    border-radius: 18px;
    z-index: -1;
    opacity: 0.8;
    animation: rpgGradientShift 4s ease-in-out infinite;
    filter: blur(1px);
  }
  
  @keyframes rpgGradientShift {
    0%, 100% {
      background-position: 0% 50%;
    }
    25% {
      background-position: 100% 0%;
    }
    50% {
      background-position: 100% 100%;
    }
    75% {
      background-position: 0% 100%;
    }
  }
  
  /* Efeito de partículas RPG */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 20%, rgba(73, 251, 176, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(36, 211, 153, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 40% 60%, rgba(29, 212, 170, 0.08) 0%, transparent 50%);
    border-radius: 16px;
    pointer-events: none;
    opacity: 0;
    animation: particleFloat 6s ease-in-out infinite;
  }
  
  @keyframes particleFloat {
    0%, 100% {
      opacity: 0;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.05);
    }
  }
  
  &:hover {
    transform: translateY(-12px) scale(1.03);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    
    &::before {
      opacity: 1;
      animation-duration: 2s;
    }
    
    &::after {
      opacity: 1;
      animation-duration: 3s;
    }
  }
  
  /* Otimização para mobile */
  @media (max-width: 768px) {
    &:hover {
      transform: translateY(-6px) scale(1.02);
    }
    
    &::before {
      animation-duration: 5s;
    }
  }
  
  @media (max-width: 480px) {
    &:hover {
      transform: translateY(-3px);
    }
    
    &::before {
      display: none;
    }
    
    &::after {
      display: none;
    }
  }
`;

// Estilos originais para cards normais
export const PlanCardContainer = styled.div`
  animation: slideInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  
  &:nth-child(1) {
    animation-delay: 0.1s;
  }
  
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  @keyframes slideInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  &:hover {
    transform: translateY(-5px);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

// Estilos para textos com linhas RPG
export const RPGText = styled.div<{ variant?: 'title' | 'feature' | 'price' }>`
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${props => {
      switch (props.variant) {
        case 'title':
          return 'linear-gradient(90deg, #49fbb0, #36d399, #2dd4aa, transparent)';
        case 'feature':
          return 'linear-gradient(90deg, rgba(73, 251, 176, 0.6), rgba(36, 211, 153, 0.4), transparent)';
        case 'price':
          return 'linear-gradient(90deg, #49fbb0, #36d399, #2dd4aa, #1ce488, transparent)';
        default:
          return 'linear-gradient(90deg, rgba(73, 251, 176, 0.4), transparent)';
      }
    }};
    border-radius: 1px;
    opacity: 0.8;
    animation: underlineGlow 3s ease-in-out infinite;
  }
  
  @keyframes underlineGlow {
    0%, 100% {
      opacity: 0.6;
      transform: scaleX(0.8);
    }
    50% {
      opacity: 1;
      transform: scaleX(1);
    }
  }
  
  &:hover::after {
    animation-duration: 1s;
    opacity: 1;
  }
`;
